export default {
	state: {
		locales: ['zh', 'en'],
		locale: 'zh'
	},
	mutations: {
		SET_LANG(state, locale) {
			if (state.locales.indexOf(locale) !== -1) {
				state.locale = locale
			}
		},
	}
}


// WEBPACK FOOTER //
// ./src/store/modules/i18n.js